import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21 4.87278C21 4.26696 21 3.96405 20.8802 3.82379C20.7763 3.70208 20.6203 3.6375 20.4608 3.65005C20.2769 3.66453 20.0627 3.87872 19.6343 4.30709L16 7.94141L19.6343 11.5757C20.0627 12.0041 20.2769 12.2183 20.4608 12.2328C20.6203 12.2453 20.7763 12.1807 20.8802 12.059C21 11.9188 21 11.6159 21 11.01V4.87278Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1 5.74141C1 4.06125 1 3.22117 1.32698 2.57943C1.6146 2.01495 2.07354 1.55601 2.63803 1.26839C3.27976 0.941406 4.11984 0.941406 5.8 0.941406H11.2C12.8802 0.941406 13.7202 0.941406 14.362 1.26839C14.9265 1.55601 15.3854 2.01495 15.673 2.57943C16 3.22117 16 4.06125 16 5.74141V10.1414C16 11.8216 16 12.6616 15.673 13.3034C15.3854 13.8679 14.9265 14.3268 14.362 14.6144C13.7202 14.9414 12.8802 14.9414 11.2 14.9414H5.8C4.11984 14.9414 3.27976 14.9414 2.63803 14.6144C2.07354 14.3268 1.6146 13.8679 1.32698 13.3034C1 12.6616 1 11.8216 1 10.1414V5.74141Z",
      stroke: "#FDBD00",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }